import React, { useEffect, useState } from 'react';
import { Button, Table } from 'reactstrap';
import { FiArrowDownCircle, FiArrowUpCircle } from 'react-icons/fi';
import { EntityStageConfigModal } from 'views/CRM/shared/components/EntityStageRuleConfig/EntityStageConfigModal';

export const OpportunityStagesConfig = ({
  opportunityStages = [],
  selectedOpportunityStages = [],
  opportunityStagesConfig,
  setOpportunityStagesConfig,
  processId,
  customFields,
  stageConfigData,
  getInfo
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [specificSalesStage, setSpecificSalesStage] = useState({});

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  useEffect(() => {
    if (opportunityStages && opportunityStages.length > 0) {
      const config = [];
      for (const stgId of selectedOpportunityStages) {
        config.push(opportunityStages.find((stg) => stg.id === stgId));
      }
      setOpportunityStagesConfig(config);
    }
  }, [
    selectedOpportunityStages,
    opportunityStages,
    setOpportunityStagesConfig
  ]);

  if (
    !opportunityStages ||
    !opportunityStages.length ||
    !selectedOpportunityStages ||
    !selectedOpportunityStages.length
  ) {
    return null;
  }

  const switchItems = (index1, index2) => {
    [opportunityStagesConfig[index1], opportunityStagesConfig[index2]] = [
      opportunityStagesConfig[index2],
      opportunityStagesConfig[index1]
    ];
    setOpportunityStagesConfig([...opportunityStagesConfig]);
  };

  const upItem = (i) => {
    const index = opportunityStagesConfig.indexOf(i);
    if (index > 0) {
      switchItems(index, index - 1);
    }
  };

  const downItem = (i) => {
    const index = opportunityStagesConfig.indexOf(i);
    if (index < opportunityStagesConfig.length - 1) {
      switchItems(index, index + 1);
    }
  };

  const stages = [
    {
      displayName: 'Aberto',
      typeNameUpper: 'OPEN'
    },
    {
      displayName: 'Fechado - Perdido',
      typeNameUpper: 'CLOSED_LOST'
    },
    {
      displayName: 'Fechado - Ganho',
      typeNameUpper: 'CLOSED_WON'
    }
  ];

  const showTypeName = (typeName) => {
    const entries = Object.values(stages);
    const name = entries.map((name) => {
      if (name.typeNameUpper === typeName) {
        return name.displayName;
      } else {
        return '';
      }
    });
    return name;
  };

  return (
    <div>
      <Table bordered={true} striped={true} size="sm" className="text-center">
        <thead>
          <tr>
            <th>Fase</th>
            <th>Editar</th>
            <th>Tipo</th>
            <th>Ordenar</th>
          </tr>
        </thead>
        <tbody>
          {opportunityStagesConfig &&
            opportunityStagesConfig.map((stage, index) => {
              if (!stage) return null;
              const stageRule = stageConfigData.find(
                (info) => info?.opportunityStageId === stage?.id
              );
              const info = {
                ...stage,
                index
              };
              if (!stage?.StageSettings && stageRule?.stageSettings) {
                info.StageSettings = stageRule.stageSettings;
              }

              return (
                <tr key={stage?.id}>
                  <td className="text-left">{stage.name}</td>
                  <td>
                    <Button
                      size="sm"
                      color="info"
                      onClick={() => {
                        setSpecificSalesStage({
                          ...info
                        });
                        toggleModal();
                      }}
                    >
                      <li className="fas fa-user-edit"></li>
                    </Button>
                  </td>
                  <td className="text-center">{showTypeName(stage.type)}</td>
                  <td>
                    {stage.type === 'OPEN' ? (
                      <div className="">
                        <FiArrowUpCircle
                          size={20}
                          cursor="pointer"
                          onClick={() => upItem(stage)}
                        />
                        <FiArrowDownCircle
                          style={{ marginLeft: '10px' }}
                          size={20}
                          cursor="pointer"
                          onClick={() => downItem(stage)}
                        />
                      </div>
                    ) : null}
                  </td>
                </tr>
              );
            })}
        </tbody>
      </Table>
      {isModalOpen && (
        <EntityStageConfigModal
          isModalOpen={isModalOpen}
          toggleModal={toggleModal}
          entityInfo={
            specificSalesStage && specificSalesStage.id
              ? specificSalesStage
              : {}
          }
          callBack={() => {
            getInfo();
          }}
          processId={processId}
          entity={'OPPORTUNITY'}
          customFields={customFields}
        />
      )}
    </div>
  );
};
